import React from 'react';
import { Segmented as AntDSegmented } from 'antd';

import './Segmented.scss';

export const Segmented = ({ options, onChange, ...props }) => {
    return <AntDSegmented className="rm-segmented" options={options} onChange={onChange} {...props} />;
};
